import { Link as RoutingLink } from 'react-router-dom';
// @mui
import { Tooltip, Stack, Typography, Link, Box, Paper } from '@mui/material';
// auth
import { useAuthContext } from '../../auth/useAuthContext';
// layouts
import LoginLayout from '../../layouts/login';
//
import AuthLoginForm from './AuthLoginForm';
// import AuthWithSocial from './AuthWithSocial';

// ----------------------------------------------------------------------

export default function Login() {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: { xs: 'stretch', md: 'center' },
        justifyContent: 'center',
        bgcolor: { xs: '#fff', md: '#f8f9fb' },
        px: { xs: 0, md: 2 },
      }}
    >
      <Paper
        elevation={0}
        sx={{
          width: '100%',
          maxWidth: { xs: '100%', md: 420 },
          p: { xs: 3, md: 4 },
          borderRadius: { xs: 0, md: 4 },
          textAlign: 'center',
          boxShadow: { xs: 'none', md: '0 8px 30px rgba(0,0,0,0.08)' },
          backgroundColor: '#fff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Stack spacing={3} alignItems="center" sx={{ width: '100%' }}>
          <Box
            component="img"
            src="/assets/illustrations/intro.png"
            alt="پلتفرم هوشمند مدیریت سازمان"
            sx={{ width: 140, maxWidth: '100%', height: 'auto' }}
          />

          <Typography variant="h5"
            sx={{ fontWeight: 600, color: '#1f2937' }}>
            ورود به پلتفرم هوشمند مدیریت سازمان
          </Typography>

          <Box sx={{ width: '100%', textAlign: 'right' }}>
            <AuthLoginForm />
          </Box>
        </Stack>
      </Paper>
    </Box>
  );
}
